// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.batch-monitor-page {
    padding: 24px;
    background-color: #f5f7fa;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.batch-monitor-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    flex-shrink: 0;
}

.job-monitor-status {
    display: flex;
    gap: 24px;
    margin-bottom: 16px;
    padding: 10px 14px;
    background: #edf2f7;
    border-radius: 8px;
    font-size: 13px;
    color: #4a5568;
}

.job-monitor-status-item {
    white-space: nowrap;
}

.batch-monitor-title {
    font-size: 24px;
    font-weight: 600;
    color: #1a202c;
    margin: 0;
}

/* Scoped to batch-monitor page only; align filters and Refresh button on same baseline */
.batch-monitor-page .batch-monitor-header .filter-section {
    display: flex;
    gap: 12px;
    align-items: flex-end;
}

.batch-monitor-page .filter-section .filter-label {
    margin: 0;
}

.batch-monitor-page .filter-section .filter-select,
.batch-monitor-page .filter-section .filter-btn {
    height: 38px;
    box-sizing: border-box;
}

.batch-monitor-page .filter-btn {
    padding: 0 16px;
    border: 1px solid #e2e8f0;
    background: white;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
}

.batch-monitor-page .filter-btn.active {
    background: #3182ce;
    color: white;
    border-color: #3182ce;
}

.filter-label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 12px;
    color: #4a5568;
}

.filter-select {
    padding: 8px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 14px;
    min-width: 180px;
    background: white;
}

.table-container {
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: white;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.table-scroll {
    flex: 1 1;
    min-height: 0;
    overflow: auto;
}

.job-monitor-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.job-monitor-table th,
.job-monitor-table td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid #e2e8f0;
}

.job-monitor-table th {
    background: #f7fafc;
    font-weight: 600;
    color: #2d3748;
}

.job-monitor-table tbody tr:hover {
    background: #f7fafc;
}

.job-monitor-table .row-exceeds {
    background: #fff5f5;
}

.empty-cell {
    text-align: center;
    color: #718096;
    padding: 24px;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    margin-bottom: 24px;
}

.stat-card {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.stat-label {
    font-size: 14px;
    color: #718096;
    margin-bottom: 8px;
}

.stat-value {
    font-size: 28px;
    font-weight: 700;
    color: #2d3748;
}

.stat-value.success {
    color: #38a169;
}

.stat-value.error {
    color: #e53e3e;
}

.loading-container,
.error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1 1;
    min-height: 200px;
    background: white;
    border-radius: 12px;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.error-message {
    color: #e53e3e;
    font-weight: 500;
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .batch-monitor-page {
    background-color: var(--app-bg);
}
[data-theme="dark"] .batch-monitor-title {
    color: var(--text);
}
[data-theme="dark"] .job-monitor-status {
    background: var(--surface-2);
    color: var(--text-muted);
}
[data-theme="dark"] .filter-label,
[data-theme="dark"] .stat-label {
    color: var(--text-muted);
}
[data-theme="dark"] .batch-monitor-page .filter-btn,
[data-theme="dark"] .filter-select {
    border-color: var(--border);
    background: var(--surface);
    color: var(--text);
}
[data-theme="dark"] .table-container,
[data-theme="dark"] .stat-card,
[data-theme="dark"] .loading-container,
[data-theme="dark"] .error-container {
    background: var(--surface);
    border: 1px solid var(--border);
}
[data-theme="dark"] .job-monitor-table th,
[data-theme="dark"] .job-monitor-table td {
    border-bottom-color: var(--border);
    color: var(--text);
}
[data-theme="dark"] .job-monitor-table th {
    background: var(--surface-2);
    color: var(--text);
}
[data-theme="dark"] .job-monitor-table tbody tr:hover {
    background: var(--surface-hover);
}
[data-theme="dark"] .job-monitor-table .row-exceeds {
    background: rgba(220, 38, 38, 0.16);
}
[data-theme="dark"] .empty-cell {
    color: var(--text-subtle);
}
[data-theme="dark"] .stat-value {
    color: var(--text);
}

/* Mobile — desktop layout above unchanged */
@media (max-width: 768px) {
    .batch-monitor-page {
        padding: 12px;
        min-height: auto;
    }

    .batch-monitor-header {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }

    .batch-monitor-title {
        font-size: 1.25rem;
    }

    .batch-monitor-page .batch-monitor-header .filter-section {
        flex-wrap: wrap;
        align-items: stretch;
        gap: 10px;
    }

    .filter-label {
        flex: 1 1 100%;
    }

    .filter-select {
        min-width: 0;
        width: 100%;
    }

    .batch-monitor-page .filter-btn {
        width: 100%;
    }

    .job-monitor-status {
        flex-direction: column;
        gap: 8px;
        padding: 12px;
    }

    .job-monitor-status-item {
        white-space: normal;
    }

    .table-container {
        padding: 12px;
        border-radius: 10px;
    }

    .table-scroll {
        -webkit-overflow-scrolling: touch;
    }

    .job-monitor-table {
        min-width: 720px;
        font-size: 12px;
    }

    .job-monitor-table th,
    .job-monitor-table td {
        padding: 8px 10px;
    }

    .stats-grid {
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }

    .stat-value {
        font-size: 22px;
    }
}

@media (max-width: 480px) {
    .stats-grid {
        grid-template-columns: 1fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/batch-monitor/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA,yFAAyF;AACzF;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,SAAO;IACP,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAO;IACP,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,4DAA4D;AAC5D;IACI,+BAA+B;AACnC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;;IAEI,wBAAwB;AAC5B;AACA;;IAEI,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;;;;IAII,0BAA0B;IAC1B,+BAA+B;AACnC;AACA;;IAEI,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;;AAEA,4CAA4C;AAC5C;IACI;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,QAAQ;QACR,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".batch-monitor-page {\n    padding: 24px;\n    background-color: #f5f7fa;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n}\n\n.batch-monitor-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n    flex-shrink: 0;\n}\n\n.job-monitor-status {\n    display: flex;\n    gap: 24px;\n    margin-bottom: 16px;\n    padding: 10px 14px;\n    background: #edf2f7;\n    border-radius: 8px;\n    font-size: 13px;\n    color: #4a5568;\n}\n\n.job-monitor-status-item {\n    white-space: nowrap;\n}\n\n.batch-monitor-title {\n    font-size: 24px;\n    font-weight: 600;\n    color: #1a202c;\n    margin: 0;\n}\n\n/* Scoped to batch-monitor page only; align filters and Refresh button on same baseline */\n.batch-monitor-page .batch-monitor-header .filter-section {\n    display: flex;\n    gap: 12px;\n    align-items: flex-end;\n}\n\n.batch-monitor-page .filter-section .filter-label {\n    margin: 0;\n}\n\n.batch-monitor-page .filter-section .filter-select,\n.batch-monitor-page .filter-section .filter-btn {\n    height: 38px;\n    box-sizing: border-box;\n}\n\n.batch-monitor-page .filter-btn {\n    padding: 0 16px;\n    border: 1px solid #e2e8f0;\n    background: white;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.batch-monitor-page .filter-btn.active {\n    background: #3182ce;\n    color: white;\n    border-color: #3182ce;\n}\n\n.filter-label {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 12px;\n    color: #4a5568;\n}\n\n.filter-select {\n    padding: 8px 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 14px;\n    min-width: 180px;\n    background: white;\n}\n\n.table-container {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    background: white;\n    padding: 24px;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.table-scroll {\n    flex: 1;\n    min-height: 0;\n    overflow: auto;\n}\n\n.job-monitor-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n}\n\n.job-monitor-table th,\n.job-monitor-table td {\n    padding: 10px 12px;\n    text-align: left;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.job-monitor-table th {\n    background: #f7fafc;\n    font-weight: 600;\n    color: #2d3748;\n}\n\n.job-monitor-table tbody tr:hover {\n    background: #f7fafc;\n}\n\n.job-monitor-table .row-exceeds {\n    background: #fff5f5;\n}\n\n.empty-cell {\n    text-align: center;\n    color: #718096;\n    padding: 24px;\n}\n\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 20px;\n    margin-bottom: 24px;\n}\n\n.stat-card {\n    background: white;\n    padding: 20px;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.stat-label {\n    font-size: 14px;\n    color: #718096;\n    margin-bottom: 8px;\n}\n\n.stat-value {\n    font-size: 28px;\n    font-weight: 700;\n    color: #2d3748;\n}\n\n.stat-value.success {\n    color: #38a169;\n}\n\n.stat-value.error {\n    color: #e53e3e;\n}\n\n.loading-container,\n.error-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n    min-height: 200px;\n    background: white;\n    border-radius: 12px;\n}\n\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-bottom: 16px;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.error-message {\n    color: #e53e3e;\n    font-weight: 500;\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .batch-monitor-page {\n    background-color: var(--app-bg);\n}\n[data-theme=\"dark\"] .batch-monitor-title {\n    color: var(--text);\n}\n[data-theme=\"dark\"] .job-monitor-status {\n    background: var(--surface-2);\n    color: var(--text-muted);\n}\n[data-theme=\"dark\"] .filter-label,\n[data-theme=\"dark\"] .stat-label {\n    color: var(--text-muted);\n}\n[data-theme=\"dark\"] .batch-monitor-page .filter-btn,\n[data-theme=\"dark\"] .filter-select {\n    border-color: var(--border);\n    background: var(--surface);\n    color: var(--text);\n}\n[data-theme=\"dark\"] .table-container,\n[data-theme=\"dark\"] .stat-card,\n[data-theme=\"dark\"] .loading-container,\n[data-theme=\"dark\"] .error-container {\n    background: var(--surface);\n    border: 1px solid var(--border);\n}\n[data-theme=\"dark\"] .job-monitor-table th,\n[data-theme=\"dark\"] .job-monitor-table td {\n    border-bottom-color: var(--border);\n    color: var(--text);\n}\n[data-theme=\"dark\"] .job-monitor-table th {\n    background: var(--surface-2);\n    color: var(--text);\n}\n[data-theme=\"dark\"] .job-monitor-table tbody tr:hover {\n    background: var(--surface-hover);\n}\n[data-theme=\"dark\"] .job-monitor-table .row-exceeds {\n    background: rgba(220, 38, 38, 0.16);\n}\n[data-theme=\"dark\"] .empty-cell {\n    color: var(--text-subtle);\n}\n[data-theme=\"dark\"] .stat-value {\n    color: var(--text);\n}\n\n/* Mobile — desktop layout above unchanged */\n@media (max-width: 768px) {\n    .batch-monitor-page {\n        padding: 12px;\n        min-height: auto;\n    }\n\n    .batch-monitor-header {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 12px;\n    }\n\n    .batch-monitor-title {\n        font-size: 1.25rem;\n    }\n\n    .batch-monitor-page .batch-monitor-header .filter-section {\n        flex-wrap: wrap;\n        align-items: stretch;\n        gap: 10px;\n    }\n\n    .filter-label {\n        flex: 1 1 100%;\n    }\n\n    .filter-select {\n        min-width: 0;\n        width: 100%;\n    }\n\n    .batch-monitor-page .filter-btn {\n        width: 100%;\n    }\n\n    .job-monitor-status {\n        flex-direction: column;\n        gap: 8px;\n        padding: 12px;\n    }\n\n    .job-monitor-status-item {\n        white-space: normal;\n    }\n\n    .table-container {\n        padding: 12px;\n        border-radius: 10px;\n    }\n\n    .table-scroll {\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .job-monitor-table {\n        min-width: 720px;\n        font-size: 12px;\n    }\n\n    .job-monitor-table th,\n    .job-monitor-table td {\n        padding: 8px 10px;\n    }\n\n    .stats-grid {\n        grid-template-columns: 1fr 1fr;\n        gap: 12px;\n    }\n\n    .stat-value {\n        font-size: 22px;\n    }\n}\n\n@media (max-width: 480px) {\n    .stats-grid {\n        grid-template-columns: 1fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
